import { NavigationExtras } from '@angular/router';

/**
 * Navigation extras for an in-page navigation that replaces the current page —
 * e.g. a grid row link to its detail page, or a detail page's back arrow. The
 * clicked control disappears with the old page, so focus would drop to <body>;
 * with this state the AppShell focuses the new page's <main> (no visible ring)
 * after it renders, so the first Tab lands on the page title — the same approved
 * behaviour as a side-nav selection (A11Y-03 / A11Y-05; approved 2026-09-25).
 *
 * Usage: `router.navigate([...], FOCUS_CONTENT_NAVIGATION)`.
 */
export const FOCUS_CONTENT_NAVIGATION: NavigationExtras = { state: { focusContent: true } };

/** True when a navigation was started with {@link FOCUS_CONTENT_NAVIGATION}. */
export function wantsContentFocus(extras: NavigationExtras | undefined): boolean {
  return extras?.state?.['focusContent'] === true;
}
